import { render, staticRenderFns } from "./dentesSegReportLineText.vue?vue&type=template&id=0ce2e954"
import script from "./dentesSegReportLineText.vue?vue&type=script&lang=js"
export * from "./dentesSegReportLineText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports